import { render, staticRenderFns } from "./SearchTipsList.vue?vue&type=template&id=60078f2a&scoped=true&"
import script from "./SearchTipsList.vue?vue&type=script&lang=js&"
export * from "./SearchTipsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60078f2a",
  null
  
)

export default component.exports